<template>
  <van-tabbar v-model="active" active-color="red" class="custom-tabbar" @change="handleTabChange">
    <van-tabbar-item icon="flower-o" class="custom-tabbar-item"
      >春信</van-tabbar-item
    >
    <van-tabbar-item icon="music-o" class="custom-tabbar-item"
      >推荐</van-tabbar-item
    >
    <van-tabbar-item icon="video-o" class="custom-tabbar-item"
      >视频</van-tabbar-item
    >
    <van-tabbar-item v-if="false" icon="home-o" class="custom-tabbar-item"
      >春信精油</van-tabbar-item
    >
    <van-tabbar-item v-if="false" icon="hot-o" class="custom-tabbar-item"
      >套餐</van-tabbar-item
    >
    <van-tabbar-item v-if="false" icon="medal" class="custom-tabbar-item"
      >健康师</van-tabbar-item
    >
    <van-tabbar-item icon="chat-o" :badge="unreadCount>0?unreadCount:''" class="custom-tabbar-item"
      >消息</van-tabbar-item
    >
    <van-tabbar-item icon="user" class="custom-tabbar-item"
      >我的</van-tabbar-item
    >
  </van-tabbar>
</template>

<script setup>
import { ref, watch, onMounted, onUnmounted } from "vue";
import { useRouter, useRoute } from "vue-router";
import { useUserStore } from "@/stores/user";
import { countUnRead } from "@/api/message";

const router = useRouter();
const route = useRoute();
const userStore = useUserStore();

// Tab 索引到路由的映射
const tabRoutes = ['/health', '/', '/video', '/message-center', '/my'];

// 根据当前路由获取应该高亮的 tab 索引
const getCurrentTabIndex = () => {
  const path = route.path;
  // 处理特殊路由映射
  if (path === '/' || path === '/top' || path.startsWith('/top?') || path.startsWith('/?')) {
    return 1; // 推荐页
  }
  const index = tabRoutes.findIndex(routePath => path === routePath || path.startsWith(routePath + '?'));
  return index >= 0 ? index : 1; // 默认选中推荐页
};

const active = ref(getCurrentTabIndex()); // 根据当前路由高亮对应菜单项

const unreadCount = ref(0); // 消息未读数量

// 轮询配置
const POLLING_INTERVAL = 5000; // 5秒轮询
let pollingTimer = null;
let isPollingStopped = false;

// 获取未读消息数
const fetchUnreadCount = async () => {
  if (isPollingStopped || !userStore.token || !pollingTimer) {
    return;
  }
  try {
    // 调用接口获取未读数量
    const count = await countUnRead();
    unreadCount.value = count;
  } catch (error) {
    console.error('获取消息未读数量失败：', error);
    unreadCount.value = 0; // 异常时置0，避免角标显示错误
  }
};

// 开始轮询
const startPolling = () => {
  if (pollingTimer || document.hidden || !userStore.token) return;
  isPollingStopped = false;
  fetchUnreadCount(); // 立即执行一次
  pollingTimer = setInterval(fetchUnreadCount, POLLING_INTERVAL);
};

// 停止轮询
const stopPolling = () => {
  if (pollingTimer) {
    clearInterval(pollingTimer);
    pollingTimer = null;
    isPollingStopped = true;
  }
};

// 页面可见性变化处理
const handleVisibilityChange = () => {
  if (document.hidden) {
    stopPolling();
  } else if (userStore.token) {
    startPolling();
  }
};

// 组件挂载
onMounted(() => {
  if (userStore.token) {
    startPolling();
  }
  // 监听页面可见性变化
  document.addEventListener('visibilitychange', handleVisibilityChange);
});

// 组件卸载
onUnmounted(() => {
  stopPolling();
  document.removeEventListener('visibilitychange', handleVisibilityChange);
});

// 处理 tab 点击
const handleTabChange = (index) => {
  const targetRoute = tabRoutes[index];
  if (targetRoute) {
    router.push(targetRoute);
  }
};

// 监听路由变化，确保tab高亮正确
watch(
  () => route.path,
  () => {
    active.value = getCurrentTabIndex();
    // 每次路由变化时刷新未读数量
    fetchUnreadCount();
  }
);

// 监听用户登录状态变化，停止
watch(
  () => userStore.token,
  () => {
    // 直接从 localStorage 检查 token，如果为空就不轮询
    const hasToken = !!localStorage.getItem('token');
    if (!hasToken) {
      stopPolling();
    } else if (!document.hidden) {
      startPolling();
    }
  }
);
</script>

<style scoped>
.custom-tabbar {
  height: 70px;
  padding-bottom: calc(-10px + var(--safe-area-inset-bottom, 0px));
  box-sizing: content-box;
}

.custom-tabbar-item {
  flex-direction: column;
  justify-content: center;
  padding-top: 6px;
}

:deep(.van-tabbar-item__icon) {
  font-size: 22px;
}

:deep(.van-tabbar-item__text) {
  font-size: 14px;
  margin-top: 2px;
}
</style>
